enum TextureKeys {
  Background = 'bg-repeat-1648x720',
  LaserEnd = 'laser-end',
  LaserMiddle = 'laser-middle',
  CoinSheet = 'coin-sheet',
  RocketMouse = 'rocket-mouse',
  ThrowItem = 'throw-item',
  PakistanFlag = 'pakistan-flag',
  AfganiFlag = 'afgani-flag',
  AlbaniaFlag = 'albania-flag',
  RussiaFlag = 'russia-flag',
  GayFlag = 'gay-flag',
  BritainFlag = 'britain-flag',
  UKFlagSheet = 'uk-flag-sheet',
  Bomb = 'bomb',
  DroneSheet = 'drone-sheet',
}

export default TextureKeys
